import { createContext, useContext } from "react";
import { AgentStore } from "./agent";
import { DeviceStore } from "./device";
import { ToolActionsStore } from "./tool-actions";
import { UIStore } from "./ui";

class RootStore {
  deviceStore: DeviceStore;
  uiStore: UIStore;
  toolActionsStore: ToolActionsStore;
  agentStore: AgentStore;

  constructor() {
    this.deviceStore = new DeviceStore(this);
    this.uiStore = new UIStore(this);
    this.toolActionsStore = new ToolActionsStore(this);
    this.agentStore = new AgentStore(this);

    if (import.meta.env.DEV) {
      (window as any).store = this;
    }
  }
}

export type RootStoreType = RootStore;

/**
 * The root store will be provided to the Provider
 */
export const rootStore = new RootStore();

/**
 * Enables us to access the store as hook inside components
 */
export function useStore() {
  const store = useContext(StoreContext);
  if (store === null) {
    throw new Error("Store cannot be null, please add a context provider");
  }
  return store;
}

export const StoreContext = createContext<RootStore | null>(null);
